import { Col, Row } from 'antd';
import React from 'react';

import { flexLayout, type TFlexLayoutProps } from '@client/utils/layout.util';

import styles from '../rebate.module.less';

type TChildrenComponentProps = {
  children?: React.ReactNode;
  childrenColProps?: TFlexLayoutProps;
};

export const ChildrenComponent: React.FC<TChildrenComponentProps> = (props) => {
  const { children, childrenColProps = flexLayout.fullColumn } = props;

  return children ? (
    <Row gutter={[24, 24]}>
      <Col {...childrenColProps}>
        <div className={styles.childrenWrapper}>{children}</div>
      </Col>
    </Row>
  ) : null;
};
